import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {IRootState} from "../../store/store";

export interface IReservationState {
    // propertyId -> epoch ms until which the property counts as reserved by the current user; availability data stays stale for a while after a confirm
    reservedByMe: Record<string, number>;
}

const initialState: IReservationState = {
    reservedByMe: {}
};

export const reservationSlice = createSlice({
    name: "reservation",
    initialState,
    reducers: {
        markReservedByMe: (state, action: PayloadAction<{propertyId: number; expiresAt: number}>) => {
            state.reservedByMe[String(action.payload.propertyId)] = action.payload.expiresAt;
        },
        // merged rather than replaced - every property page hydrates on mount, possibly after a confirm in this session
        hydrateReservedByMe: (state, action: PayloadAction<Record<string, number>>) => {
            Object.entries(action.payload).forEach(([propertyId, expiresAt]) => {
                const current = state.reservedByMe[propertyId];

                if (current === undefined || current < expiresAt) {
                    state.reservedByMe[propertyId] = expiresAt;
                }
            });
        },
        clearReservedByMe: (state) => {
            state.reservedByMe = {};
        }
    }
});

export const {markReservedByMe, hydrateReservedByMe, clearReservedByMe} = reservationSlice.actions;

export const selectReservedByMeUntil = (propertyId: number) => (state: IRootState) => state.reservation.reservedByMe[String(propertyId)] ?? null;
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {IRootState} from "../../store/store";

export interface IReservationState {
    // propertyId -> epoch ms until which the property counts as reserved by the current user; availability data stays stale for a while after a confirm
    reservedByMe: Record<string, number>;
}

const initialState: IReservationState = {
    reservedByMe: {}
};

export const reservationSlice = createSlice({
    name: "reservation",
    initialState,
    reducers: {
        markReservedByMe: (state, action: PayloadAction<{propertyId: number; expiresAt: number}>) => {
            state.reservedByMe[String(action.payload.propertyId)] = action.payload.expiresAt;
        },
        // merged rather than replaced - every property page hydrates on mount, possibly after a confirm in this session
        hydrateReservedByMe: (state, action: PayloadAction<Record<string, number>>) => {
            Object.entries(action.payload).forEach(([propertyId, expiresAt]) => {
                const current = state.reservedByMe[propertyId];

                if (current === undefined || current < expiresAt) {
                    state.reservedByMe[propertyId] = expiresAt;
                }
            });
        },
        clearReservedByMe: (state) => {
            state.reservedByMe = {};
        }
    }
});

export const {markReservedByMe, hydrateReservedByMe, clearReservedByMe} = reservationSlice.actions;

export const selectReservedByMeUntil = (propertyId: number) => (state: IRootState) => state.reservation.reservedByMe[String(propertyId)] ?? null;
